import React, { useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import { Outlet } from "react-router-dom";
import PageLoader from "./PageLoader";

const AdminLayout = () => {
	const [loading, setLoading] = useState(false);

	return (
		<div className="fixed-navbar page-wrapper">

			{/* Sidebar */}
			<div className="sidebar-container">
				<Sidebar />
			</div>

			{/* Header */}
			<div className="header-container">
				<Header />
			</div>

			{/* Main Content */}
			<div style={styles.content}>
				{loading && <PageLoader />}
				<Outlet context={{ setLoading }} />

				<Footer />
			</div>
		</div>
	);
};

const styles = {
	content: {
		marginLeft: "220px",
		marginTop: "70px",
		padding: "20px",
		background: "#f3f3f4",
		minHeight: "100vh",
	},
};

export default AdminLayout;